'use strict';

angular.module('shiftTraderApp')
    .directive('saFooterWeekBudget', function ($compile, $timeout, TimeService, $filter, $rootScope, UtilityService, OverlayManagementService) {
      var tooltipTemplate = '<div class="footer_week_budget_tooltip sa_footer_tooltip_wrapper" ' +
        'sa-footer-week-budget-area="weekData" org="org" week-twix="weekTwix"></div>';
      return {
        templateUrl: 'views/directives/saFooterWeekBudget.html',
        restrict: 'A',
        scope: {
          weekTwix: '='
        },
        link: function link (scope, elem) {
          var bindsSet = false;
          var openDelay = 300;

          var tooltipTemplateLinker = $compile(tooltipTemplate);

          var tooltipOpenState = false;
          var tooltip;
          var tappedOpen;
          var tooltipTimeout;
          var hoverDebounce;

          var positionTooltip = function () {
            var tooltipIndicatorArrow = $(tooltip).find('.sa_footer_day_down_arrow');
            var dayAreaHeight = $(elem).outerHeight();
            var dayAreaWidth = $(elem).outerWidth();
            var arrowHeight = 10;

            var tooltipWidth = tooltip.outerWidth();

            tooltip.css({
              top: dayAreaHeight + arrowHeight,
              left:  (-1 * tooltipWidth + dayAreaWidth)
            });
          };

          var hoverIn = function () {
            if (scope.hideWeekBudgetSpinner) {
              $(elem).addClass('hovering');

              if (!_.isUndefined(hoverDebounce)) {
                $timeout.cancel(hoverDebounce);
              }

              if (!tooltipOpenState) {
                toggleTooltipOpen();
              }
            }
          };

          var hoverOut = function () {
            if (scope.hideWeekBudgetSpinner) {
              $(elem).removeClass('hovering');

              hoverDebounce = $timeout(function () {
                if (!tappedOpen) {
                  closeTooltip(true);
                }
              }, 250);
            }
          };

          var openTooltip = function () {
            if (!tooltipTimeout) {
              tooltipTimeout = $timeout(function() {
                tooltip = tooltipTemplateLinker(scope, function () {});
                tooltip.css({bottom: 0, left: 0, display: 'block', 'z-index': 11000});
                elem.append( tooltip );
                positionTooltip();
                scope.$digest();
                tooltipOpenState = true;
                $timeout(function() {
                  tooltip.addClass('active');
                  OverlayManagementService.addOverlay('mwpGuideBar', 'week', function() {
                    closeTooltip(true);
                    tappedOpen = false;
                  });
                }, 0);

              }, openDelay);
            }
          };

          var closeTooltip = function (animate) {
            tooltipOpenState = false;
            $timeout.cancel(tooltipTimeout);
            tooltipTimeout = undefined;
            if (tooltip) {
              if (animate) {
                tooltip.removeClass('active');
                OverlayManagementService.removeOverlay('mwpGuideBar', 'week');
                $timeout(function() {
                  if (tooltip) {
                    tooltip.remove();
                  }
                  tooltip = null;
                }, 300);
              } else {
                OverlayManagementService.removeOverlay('mwpGuideBar', 'week');
                tooltip.remove();
                tooltip = null;
              }
            }

          };

          var toggleTooltipOpen = function () {
            if (!tooltipOpenState) {
              openTooltip();
            } else {
              closeTooltip(true);
            }
          };


          // Make sure tooltip is destroyed and removed.
          scope.$on('$destroy', function onDestroyTooltip() {
            closeTooltip(false);
            tappedOpen = false;
          });

          scope.orgWeeklyBudget = undefined;
          scope.orgWeeklyBudgetIsSet = false;
          scope.hideWeekBudgetSpinner = false;

          scope.state = {
            openPulldown: false,
            processedDataLoaded: false,
            weekNumberUpdateDeferred: false
          };

          var currencyFilter = $filter('currency');
          scope.$on('sa:manageWorkPeriod:projectionsWeekProcessingStatus', function(event, data) {
            //$log.log('sa:manageWorkPeriod:projectionsWeekProcessingStatus', data);
            if (data) {
              scope.data = data;
              scope.org = data.org;
              scope.weekData = data.dayAnalysisDataByDay;
              scope.currentView = scope.data.currentView;
              scope.weekNumber = TimeService.getWorkWeekNumberFromMoment(scope.weekTwix.start);
              scope.currentDayIndex = scope.data.dayIndex;


              scope.currentCost = _.reduce(scope.weekData, function(accum, day) {
                return accum + day.laborCost;
              }, 0);

              if (scope.data.projections && scope.data.projections.byDay) {
                var weekGrossRevenue = _.reduce(scope.data.projections.byDay, function(sum, datum) {
                  var diff = ((_.isUndefined(datum.data.total) || _.isNull(datum.data.total.gross_revenue) || datum.data.total.gross_revenue === '') ? 0 : datum.data.total.gross_revenue);
                  return sum + diff;
                }, 0);

                if (weekGrossRevenue > 0) {
                  scope.currentLaborPercentage = scope.currentCost / weekGrossRevenue * 100;
                } else {
                  scope.currentLaborPercentage = null;
                }
              } else {
                scope.currentLaborPercentage = null;
              }

              scope.laborPercentageGoal = scope.data.projections ? scope.data.projections.weekLaborPercentageGoal: null;

              scope.currentLaborHours = _.reduce(scope.weekData, function(accum, day) {
                return accum + day.totalLaborHours;
              }, 0);

              scope.averageHourlyWage = scope.currentCost / scope.currentLaborHours;

              if (scope.currentView === 'cost') {
                scope.currentNumberVal = scope.currentCost;
                scope.currentNumber = currencyFilter(scope.currentCost);
                if (scope.data.projections && _.any(scope.data.projections.byDay, function(datum) {
                    return !_.isUndefined(datum.data.total) && !_.isNull(datum.data.total.cost) && datum.data.total.cost !== '';
                  })) {
                  scope.currentProjectionVal = _.reduce(scope.data.projections.byDay, function(sum, proj) {
                    return sum + ((_.isUndefined(proj.data.total) || _.isNull(proj.data.total.cost) || proj.data.total.cost === '') ? 0 : proj.data.total.cost);
                  }, 0);
                  scope.currentProjection = currencyFilter(scope.currentProjectionVal);
                } else {
                  scope.currentProjection = null;
                  scope.currentProjectionVal = null;
                }
              } else if (scope.currentView === 'laborHours') {
                scope.currentNumberVal = scope.currentLaborHours;
                scope.currentNumber = scope.currentLaborHours.toFixed(1) + ' hrs';

                if (scope.data.projections && _.any(scope.data.projections.byDay, function(datum) {
                    return !_.isUndefined(datum.data.total) && !_.isNull(datum.data.total.labor_hours) && datum.data.total.labor_hours !== '';
                  })) {
                  scope.currentProjectionVal = _.reduce(scope.data.projections.byDay, function(sum, proj) {
                    return sum + ((_.isUndefined(proj.data.total) || _.isNull(proj.data.total.labor_hours) || proj.data.total.labor_hours === '') ? 0 : proj.data.total.labor_hours);
                  }, 0);

                  scope.currentProjection = scope.currentProjectionVal.toFixed(1) + ' hrs';
                } else {
                  scope.currentProjection = null;
                  scope.currentProjectionVal = null;
                }
              } else if (scope.currentView === 'laborPercentage') {
                if (!_.isNull(scope.currentLaborPercentage)) {
                  scope.currentNumberVal = scope.currentLaborPercentage;
                  scope.currentNumber = scope.currentLaborPercentage.toFixed(2) + '%';
                } else {
                  scope.currentNumber = null;
                  scope.currentNumberVal = null;
                }
                if (scope.laborPercentageGoal) {
                  scope.currentProjectionVal = scope.laborPercentageGoal;
                  scope.currentProjection = scope.laborPercentageGoal.toFixed(2) + '%';
                } else {
                  scope.currentProjectionVal = null;
                  scope.currentProjection = null;
                }
              }

              var color;
              var e = elem.find('.left .top_metric .metric_inner');
              if (!_.isNull(scope.currentProjectionVal) && !_.isNull(scope.currentNumberVal)) {
                color = UtilityService.calcColorWithGoal(scope.currentProjectionVal,
                  scope.currentNumberVal,
                  100, 110);
                e.css({
                  color: color
                });
              } else {
                e.css({
                  color: ''
                });
              }

              e = elem.find('.right .bottom_metric .metric_inner');
              if (!_.isNull(scope.currentLaborPercentage) && !_.isNull(scope.laborPercentageGoal)) {
                color = UtilityService.calcColorWithGoal(scope.laborPercentageGoal,
                  scope.currentLaborPercentage,
                  100, 110);
                e.css({
                  color: color
                });
              } else {
                e.css({
                  color: ''
                });
              }

              // update the week publish area
              scope.weekPublishData = {
                weekPublished: _.any(scope.weekData, function(day) {
                  return day.publishData.dayPublished;
                }),
                weekNotAllPublished: _.any(scope.weekData, function(day) {
                  return day.publishData.dayNotAllPublished;
                }),
                weekHasShifts: _.any(scope.weekData, function(day) {
                  return day.publishData.dayHasShifts;
                }),
                weekHasUnassigned: _.any(scope.weekData, function(day) {
                  return day.publishData.dayHasUnassigned;
                })
              };

              scope.loadCompleted = true;

              if (!bindsSet) {
                $(elem).bind('mousedown touchdown', function (event) {
                  if (scope.hideWeekBudgetSpinner) {
                    if ($.contains(elem.get()[0], event.target)) {
        //              console.log('contains!');
                    } else {
        //              console.log('does not contains');
                      if (tooltipOpenState) {
        //                console.log('cleared tappedOpen');
                        tappedOpen = true;
                      } else {
        //                console.log('set tappedOpen');
                        tappedOpen = false;
                      }
                      toggleTooltipOpen();
                    }
                    event.stopPropagation();
                  }
                });

                if (!$rootScope.isIpad) {
                  $(elem).hover(hoverIn, hoverOut);
                }

                bindsSet = true;
              }

              scope.hideWeekBudgetSpinner = true;
              scope.state.processedDataLoaded = true;

              if (scope.state.weekNumberUpdateDeferred) {
                doTemplateHoursUpdate();
                scope.state.weekNumberUpdateDeferred = false;
              }
            } else {
              scope.hideWeekBudgetSpinner = false;
            }
          });

          scope.$on('sa:manageWorkPeriod:dateChange', function() {
            //console.log((new Date()).getMilliseconds(), '$ON ', event.name);
            resetTemplateHours();
          });

          scope.shiftsOnScreenById = {};

          var pulldownTimeout = null;

          var getShiftLength = function(s) {
            if (s.editingTwix) {
              return s._dismissed ? 0 : Math.abs(s.editingTwix.length('minutes') / 60.0);
            } else {
              return s._dismissed ? 0 : Math.abs(s.range_twix.length('minutes') / 60.0);
            }
          };

          var templateHoursUpdateTimeout; // timeout for updating template hours. Want to make sure it doesn't get triggered 100 times for one update!
          var doTemplateHoursUpdate = function() {
            if (templateHoursUpdateTimeout) {
              //$log.log('templateHoursUpdateTimeout cancelled');
              $timeout.cancel(templateHoursUpdateTimeout);
            }

            templateHoursUpdateTimeout = $timeout(function() {
              //$log.log('templateHoursUpdateTimeout fired');
              if (scope.data.projections && scope.data.projections.byDay[scope.data.dayIndex]) {
                scope.hoursGoal = scope.data.projections.byDay[scope.data.dayIndex].data.total.labor_hours;
              }

              writeNumShiftTemplateHours();

              if (pulldownTimeout) {
                $timeout.cancel(pulldownTimeout);
              }

              var pulldownElem = $(elem).find('.sa_mwp_week_pulldown');

              //scope.state.openPulldown = true;
              pulldownElem.addClass('open');

              pulldownTimeout = $timeout(function() {
                pulldownElem.removeClass('open');
                //scope.state.openPulldown = false;
              }, 5000);

              $timeout.cancel(templateHoursUpdateTimeout);
            }, 100);
          };

          scope.$on('sa:manageWorkPeriod:templateHoursUpdated', function(event, shift) {
            //console.log((new Date()).getMilliseconds(), '$ON ', event.name, shift.id, shift.shift_template_id);
            scope.shiftsOnScreenById[shift.id] = shift;

            scope.numShiftTemplateHours = _.reduce(_.map(scope.shiftsOnScreenById, function(s) {
              return getShiftLength(s);
            }), function(sum, num) {
              return sum + num;
            }, 0);

            if (scope.state.processedDataLoaded) {
              doTemplateHoursUpdate();
            } else {
              scope.state.weekNumberUpdateDeferred = true;
            }
          });

          var writeNumShiftTemplateHours = function() {
            // only do the update if the appropriate data is loaded, so this IF is here...
            if (scope.weekData && !_.isUndefined(scope.currentDayIndex) && scope.weekData[scope.currentDayIndex]) {

              var temp = $filter('number')(scope.numShiftTemplateHours + scope.weekData[scope.currentDayIndex].totalLaborHours, 2);
              var html = '<div class="major">' + temp.split('.')[0] + '</div>';
              html +=    '<div class="minor">' + temp.split('.')[1] + '</div>';
              html +=    '<div class="shift_template_hour_label">hrs</div>';

              var e = $('.work_period_container .num_shift_template_hours');
              e.html(html);
              var pulldown = $('.work_period_container .sa_mwp_week_pulldown');

              if (scope.hoursGoal) {
                var color = UtilityService.calcColorWithGoal(scope.hoursGoal,
                  scope.numShiftTemplateHours + scope.weekData[scope.currentDayIndex].totalLaborHours,
                  100, 110);
                e.css({
                  color: color
                });

                pulldown.css({
                  'border-color': tinycolor(color).desaturate(20)
                });

              } else {
                e.css({
                  color: ''
                });

                pulldown.css({
                  'border-color': ''
                });
              }

            }

          };

          var resetTemplateHours = function() {
            //console.log('resetTemplateHours!');
            scope.shiftsOnScreenById = {};
            scope.numShiftTemplateHours = 0;
            writeNumShiftTemplateHours();
          };

          var currTemplateId;


          //TODO: need to also take care of date changes, should force hour recalc
          scope.$on('sa:manageWorkPeriod:selectedTemplateChange', function(event, template) {
            //console.log((new Date()).getMilliseconds(), '$ON ', event.name, template);
            //console.log('currTemplateId', currTemplateId, template.id, template.id !== currTemplateId);
            if (_.isUndefined(currTemplateId)) {
              currTemplateId = parseInt(template.id);
            } else {
              if (template.id && parseInt(template.id) > 0 && parseInt(template.id) !== parseInt(currTemplateId)) {
                //console.log('resetTemplateHours', 'was : ', scope.numShiftTemplateHours, 'RESETTING');
                resetTemplateHours();
              }
            }
          });

          scope.openSetProjections = function($event) {
            $rootScope.$broadcast('sa:manageWorkPeriod:openSetProjections');
            $event.stopPropagation();
          };
        }
      };
    });
